import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=7527ec8b&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=7527ec8b&prod&lang=scss&scoped=true&"
import style1 from "./CategoryList.vue?vue&type=style&index=1&id=7527ec8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527ec8b",
  null
  
)

export default component.exports